import { LittleModalCreateEdit } from '../../../../../../baseComponents/ModalsLayouts/ModalCreateEdit'
import { FormRender } from '../../../../../../forms/FormRenderer/types'
import useTwinTranslation from '../../../../../../utils/hooks/useTwinTranslation'
import {LabelModelType} from '@teinor/erp/types/company/config/label' 
import { ModalComponentProps } from '../../../../../../baseComponents/ModalsLayouts/types'
import { useCallback } from 'react'
import { changeErrorMessage } from '../../../../../../utils/reducers/reduxDispatch'
import { TwinDictionary } from '../../../../../../utils/globals/dictionary'

interface ModalCreateLabelExtended extends LabelModelType {
    product_reference: string
    product_barcode: string
    product_name: string
    product_price: string
    product_price_simple: string
    product_variant: string
    product_custom_code_bar: string
    product_cost_hidden: string
    product_brand: string
    product_secondaryReference: string
    product_quantity: string
    product_order_notes: string
    product_short_description_docs: string
    product_weight: string
    product_supplier: string
    product_supplier_code: string
    product_buy_date: string
    order_custom_name: string
}

interface ModalCreateLabelProps extends ModalComponentProps{}

const ModalCreateLabel: React.FC<ModalCreateLabelProps> = ({ ...rest }) => {
    const { t } = useTwinTranslation()
    const { handleBeforeSubmit } = useModalCreateLabelLogic()
    const fields: FormRender<ModalCreateLabelExtended> = [
        {
            cols: 1,
            elements: [
                {
                    name: 'name',
                    label: t('name', 'Nombre'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                    required: true
                },
                {
                    name: 'product_name',
                    label: t('productNameInTag', 'Nombre del producto en la etiqueta'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                },
                {
                    name: 'product_price',
                    label: t('productPriceSInTag', 'Precio del producto en la etiqueta'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                },
                {
                    name: 'product_price_simple',
                    label: t('priceSimple', 'Precio simple'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                },
                {
                    name: 'product_variant',
                    label: t('variantOfProduct', 'Variante del producto'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                },
                {
                    name: 'product_reference',
                    label: t('productReferenceInTag', 'Referencia del producto en la etiqueta'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                },
                {
                    name: 'product_barcode',
                    label: t('productBarCodeInTag', 'Código de barras del producto en la etiqueta'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                },
                {
                    name: 'product_custom_code_bar',
                    label: t('productCustomBarCodeInTag', 'Código de barras personalizado del producto en la etiqueta'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                },
                {
                    name: 'product_secondaryReference',
                    label: t('productSecondaryReferenceInTag', 'Referencia secundaria del producto en la etiqueta'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                },
                {
                    name: 'product_short_description_docs',
                    label: t('productShortDescriptionDocsInTag', 'Descripción corta del producto en la etiqueta'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                },
                {
                    name: 'product_quantity',
                    label: t('productQuantityInTag', 'Cantidad del producto en la etiqueta'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                },
                {
                    name: 'product_order_notes',
                    label: t('productOrderNotes', 'Notas del producto en el pedido'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                },
                {
                    name: 'order_custom_name',
                    label: t('customNameOrder', 'Nombre personalizado pedido'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                },
                {
                    name: 'product_cost_hidden',
                    label: t('costPriceHidden', 'Precio Coste oculto'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                },
                {
                    name: 'product_brand',
                    label: t('productBrand', 'Marca del producto'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                },
                {
                    name: 'product_weight',
                    label: t('productWeight', 'Peso del producto'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                },
                {
                    name: 'product_supplier',
                    label: t('productSupplier', 'Proveedor del producto'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                },
                {
                    name: 'product_supplier_code',
                    label: t('productSupplierCode', 'Código del proveedor del producto'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                },
                {
                    name: 'product_buy_date',
                    label: t('productBuyDate', 'Fecha de compra del producto'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                },
                {
                    name: 'variants_print',
                    label: t('productVariantIdsPrint', 'Ids de las variantes a imprimir'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                },
                {
                    name: 'force_printer',
                    label: t('forcePrinter', 'Forzar impresora'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                },
                {
                    name: 'original_template',
                    label: t('uploadTag', 'Subir etiqueta'),
                    component: 'FilesInput',
                    acceptFileConditions: {
                        'text': ['.zpl', '.prn', '.txt']
                    }
                },
            ]
        },
    ]
    
    return (<LittleModalCreateEdit fields={fields} imagePath={['tmp']} url={'/api/app/config/label/createLabel'} translations={{
        title: t('createLabel', 'Crear etiqueta'),
        button: t('create', 'Crear')
    }} haveButtonPermissions={true} {...rest} beforeSubmit={handleBeforeSubmit}/>)
}

const useModalCreateLabelLogic = () => {
    const {t} = useTwinTranslation()
    const errorMessageFile = t('addFile', 'Introduzca un fichero')

    const handleBeforeSubmit = useCallback((values: any) => {
        if (!values.original_template) {
            changeErrorMessage(errorMessageFile)
            return false
        }
        let variables_setted: TwinDictionary = {}
        for (const key in values) {
            const value = values[key]
            if (value && key !== 'name' && key !== 'original_template') {
                variables_setted[key] = value
            }
        }
        values.variables_setted = variables_setted
        return true
    }, [errorMessageFile])
    
    return { handleBeforeSubmit }
}

export default ModalCreateLabel